export { TablePermissions } from './table-permissions'; 
